import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-closing-pack-modal',
  templateUrl: './closing-pack-modal.component.html',
  styleUrls: ['./closing-pack-modal.component.less']
})
export class ClosingPackModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
